import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#4BB7C0",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m8.123 8.842-.464.335.164-.56-.45-.355.564-.012.186-.553.186.553.565.012-.45.354.163.561zm2.105 0-.464.335.164-.56-.45-.355.565-.012.185-.553.186.553.565.012-.45.354.163.561zm2.105 0-.464.335.164-.56-.45-.355.565-.012.185-.553.186.553.565.012-.45.354.163.561zm2.106 0-.464.335.164-.56-.451-.355.565-.012.186-.553.185.553.566.012-.45.354.163.561zm2.105 0-.464.335.164-.56-.451-.355.565-.012.186-.553.185.553.566.012-.45.354.163.561zM10.228 6.66l-.464.335.164-.56-.45-.354.565-.012.185-.554.186.554.565.011-.45.354.163.561zm2.105 0-.464.335.164-.56-.45-.354.565-.012.185-.554.186.554.565.011-.45.354.163.561zm2.106 0-.464.335.164-.56-.451-.354.565-.012.186-.554.185.554.566.011-.45.354.163.561zm2.105 0-.464.335.164-.56-.451-.354.565-.012.186-.554.185.554.566.011-.45.354.163.561zm-4.211-2.181-.464.334.164-.56-.45-.354.565-.012.185-.554.186.554.565.012-.45.354.163.56zm2.106 0-.464.334.164-.56-.451-.354.565-.012.186-.554.185.554.566.012-.45.354.163.56zm2.105 0-.464.334.164-.56-.451-.354.565-.012.186-.554.185.554.566.012-.45.354.163.56zm-9.21-1.766C5.712 2.977 4.476 4.348 4.476 6s1.236 3.023 2.858 3.287q-.28.045-.572.046C4.87 9.333 3.334 7.841 3.334 6c0-1.84 1.535-3.333 3.428-3.333q.293 0 .572.046",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.178 12h31.66c.133 1.384.175 2.738.159 4.016A35 35 0 0 1 31.822 20H.166a36 36 0 0 1-.163-4.017A35 35 0 0 1 .178 12",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagUzb = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagUzb_default = SvgFlagUzb;

export { FlagUzb_default as default };
